import React from 'react';
import { Col } from 'react-bootstrap';

const FormCol9 = (props) => (
  <Col sm={12} lg={9} xl={9} {...props}>
    {props.children}
  </Col>
);

export default FormCol9;

